import React from 'react';
import { PageDialog } from '../../components/PageDialog';
import { useTranslation } from 'react-i18next';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { Link as MuiLink, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

interface Props {
  shortLink: string;
}

const StyledLink = styled(MuiLink)(({ theme }) => ({
  marginTop: theme.spacing(1),
  fontSize: theme.typography.body2.fontSize,
  display: 'block',
  marginBottom: theme.spacing(1),
}));

export const GroupOrderInfo = ({ shortLink }: Props) => {
  const history = useHistory();
  const location = useLocation<{ groupOrderInfo?: boolean }>();
  const { t, i18n } = useTranslation();

  const open = location.hash === '#group';

  return (
    <>
      <Typography variant={'body1'} component={'h4'}>
        {t('checkout.group_order_info.headline')}
      </Typography>
      <StyledLink href={'#group'}>{t('checkout.group_order_info.link')}</StyledLink>
      <PageDialog title={t('checkout.group_order_info.dialog.title')} open={open} onBack={history.goBack}>
        <Typography paragraph={true}>{t('checkout.group_order_info.dialog.content_1')}</Typography>
        <Typography paragraph={true}>
          {t('checkout.group_order_info.dialog.content_2_1')}
          <MuiLink component={Link} to={`/${i18n.language}/tour/${shortLink}/voucher`}>
            {t('checkout.group_order_info.dialog.content_2_2')}
          </MuiLink>
          {t('checkout.group_order_info.dialog.content_2_3')}
        </Typography>
        <Typography paragraph={true}>
          {t('checkout.group_order_info.dialog.content_3_1')}
          <MuiLink href={'mailto:booking@lialo.com'}>{t('checkout.group_order_info.dialog.content_3_2')}</MuiLink>
          {t('checkout.group_order_info.dialog.content_3_3')}
        </Typography>
      </PageDialog>
    </>
  );
};
